import { HeaderTemplateComponent } from './header-template/header-template.component';

export { HeaderTemplateComponent };

export default [HeaderTemplateComponent];
